import BaseInstance from "../BaseInstance";

const UserGateway = {
  searchUser: async (searchUrl: string) => {
    return BaseInstance.get(`/users/search-autocomplete?textSearch=${searchUrl}`);
  },
  checkEmails: async (emails: string[]): Promise<{ valid: boolean; invalidEmails: string[] }> => {
    return BaseInstance.post("/users/check", { emails });
  },
};

export default UserGateway;
